import delve from "../utils/delve";
import interpolate from "../utils/interpolate";
var translate = function (dict, key, values) {
    var str = delve(dict, key);
    return values ? interpolate(str, values) : str;
};
export var createI18n = function (dict) { return ({
    text: translate.bind(null, dict),
}); };
export { Language } from "./Language";
